export const FIND_EMPLOYEE_ROLES_FAILURE = 'FIND_EMPLOYEE_ROLES_FAILURE';

export const findEmployeeRolesFailure = ({ error, request }) => ({
    type: FIND_EMPLOYEE_ROLES_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});